import { Stack } from "@mui/material";
import InfoContextPanel from ".";
import { useTranslation } from "react-i18next";

export default function InfoContextPanelExamples() {
  const { t } = useTranslation();

  return (
    <Stack spacing={2}>
      <InfoContextPanel
        text="Moses Tshabalala"
        title={t("SelectedDependantPanel.title")}
      />
      <InfoContextPanel
        title={t("SelectedDependantPanel.title")}
        text="Moses Tshabalala"
        compact
        compactText="Moses Tshabalala"
      />
      <InfoContextPanel
        title={t("InfoContextPanel.vouchers.title")}
        icon="CloudStatusIcon"
        text={t("InfoContextPanel.vouchers.BloodTestVoucher.subtitle")}
      />
      <InfoContextPanel
        title={t("InfoContextPanel.vouchers.title")}
        text={t("InfoContextPanel.vouchers.BloodTestVoucher.subtitle")}
        compact
        compactText={t("InfoContextPanel.vouchers.compact.subtitle")}
        compactIcon="StackedCardsIcon"
      />
    </Stack>
  );
}
